import i18n from "i18next";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Route } from "react-router-dom";
import { Divider, Dropdown } from "semantic-ui-react";

import RepairImg from "assets/img/repair.svg";
import { Logo } from "components";
import { LoginForm, ResetPassword, ResetPasswordRequest } from "modules/Login/components";
import { useRedirectToLandingPage } from "modules/Login/hooks";
import "modules/Login/Login.scss";
import { PATHS } from "router/paths";
import { getBrowserLanguage, languages } from "utils/common";

// eslint-disable-next-line no-relative-import-paths/no-relative-import-paths
import packageJson from "../../../package.json";

const getInitialLanguage = (): string => {
  const storedLanguage = localStorage.getItem("locale");
  if (storedLanguage) return storedLanguage;

  const browserLanguage = getBrowserLanguage(false);
  localStorage.setItem("locale", browserLanguage);

  return browserLanguage;
};

export const Login = () => {
  const [selectedLanguage, setSelectedLanguage] = useState(getInitialLanguage);
  const { t } = useTranslation();

  useRedirectToLandingPage(true);

  const handleLanguageChange = (_e: React.SyntheticEvent, data: any) => {
    const selectedLanguage = localStorage.getItem("locale");

    if (selectedLanguage !== data.value) {
      i18n.changeLanguage(data.value, () => {
        i18n.reloadResources([data.value], ["translations"], () => {
          localStorage.setItem("locale", data.value);
          setSelectedLanguage(data.value);
        });
      });
    }
  };

  return (
    <div className="Login">
      <div className="overlay">
        <div className="container">
          <img className="repair_img" src={RepairImg} />
          <div className="rhs">
            <Logo />
            <div className="rhs_box">
              <Route exact path={[PATHS.HOME, PATHS.LOGIN]} render={() => <LoginForm />}></Route>
              <Route exact path={PATHS.RESET_PASSWORD} render={() => <ResetPassword />}></Route>
              <Route exact path={PATHS.RESET_PASSWORD_REQUEST} render={() => <ResetPasswordRequest />}></Route>
              <Divider horizontal className="divider">
                <span>{t("v8_select_language", "Select language")}</span>
              </Divider>
              <div className="select-language-dropdown mt-15">
                <Dropdown selectOnBlur={false} fluid selection options={languages} value={selectedLanguage} onChange={handleLanguageChange} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer">
        <p>{packageJson.version}</p>
        <a href="https://www.claireautomotive.com/" target="blank">
          clairesoftware.nl
        </a>
        <a href="https://www.claireautomotive.com/support" target="blank">
          {t("v8_support", "Support")}
        </a>
        <p>+31 (0) 88 232 22 22</p>
      </div>
    </div>
  );
};
